import React, { useState, useEffect } from 'react';
import { RichUtils, EditorState } from 'draft-js';
import { getSelectedBlock } from 'draftjs-utils';

// Constants
import ToolbarConfig from '../../Toolbar/toolbar.config';

// Components
import Control from '../Control/Control';

type Props = {
  editorState: EditorState;
  onChange?: Function;
  block: string;
};

const List = ({ editorState, onChange, block }: Props) => {
  const [currentBlock, setCurrentBlock] = useState(getSelectedBlock(editorState));
  const config = ToolbarConfig.find(item => item.block === block);
  const active = currentBlock.get('type') === block;

  const toggleBlockType = () => {
    const newState = RichUtils.toggleBlockType(editorState, config.block);
    if (newState) {
      onChange(newState);
    }
  };

  useEffect(() => {
    setCurrentBlock(getSelectedBlock(editorState));
  }, [editorState]);

  return <Control key={config.block} icon={config.icon} onClick={toggleBlockType} active={active} />;
};

export default List;
